import { createSlice } from '@reduxjs/toolkit';
import { TerritoryManagerType } from '@repo/backoffice-api';

const initialState: { territoryManagers: TerritoryManagerType[] } = {
  territoryManagers: [],
};

export const territoryManagersSlice = createSlice({
  name: 'territoryManagers',
  initialState,
  reducers: {
    pushTerritoryManagers: (state, action: { payload: TerritoryManagerType[] }) => ({
      ...state,
      territoryManagers: action.payload,
    }),
    resetTerritoryManagers: () => initialState,
  },
});

export const { pushTerritoryManagers, resetTerritoryManagers } = territoryManagersSlice.actions;

export default territoryManagersSlice.reducer;
